module.exports = __webpack_public_path__ + "img/generator.645ba690.svg";